import { ConfAccount } from "../../context/account/paramsAccount";
import { saveCredentials } from "../localStorage/saveLocalStorage";

export function handleActivateOfflineMode(setConf: React.Dispatch<React.SetStateAction<ConfAccount>>, conf: ConfAccount, toggleOfflineMode: any) {

    const newConf: any = {
        ...conf,
        conf: {
            ...conf.conf,  // Copie toutes les propriétés de conf.conf
            ifOffLineMode: !conf.conf.ifOffLineMode,  // Modifie la propriété isOfflineMode
        }
    };
    setConf(newConf);
    saveCredentials({
        ...newConf,
    },
        conf,
        setConf,
        conf.user.user_code
    );
    toggleOfflineMode(true)
}
export function handleDesactivateOfflineMode(setConf: React.Dispatch<React.SetStateAction<ConfAccount>>, conf: ConfAccount, toggleOfflineMode: any) {
    const newConf: any = {
        ...conf,
        conf: {
            ...conf.conf,
            ifOffLineMode: false,
        }
    };
    setConf(newConf);
    saveCredentials({
        ...newConf,
    },
        conf,
        setConf,
        conf.user.user_code);
    toggleOfflineMode(false)
}